/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { VideoPageEventType } from './videoPageEventType'

export interface VideoPageTrackEventInput {
  referrer?: string
  deviceType?: string
  userAgent?: string
  ipAddress?: string
  eventData?: unknown
  eventType: VideoPageEventType
  sessionId: string
  videoId: Cuid
}
